/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import 'aisztheme';
import 'aisztheme/sass/animate.scss';

import React from 'react';
import CSSModules from 'react-css-modules';
import {
  Button,
  Grid,
  Row,
  Col,
  Panel,
  Modal,
} from 'react-bootstrap';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import {
  defineMessages,
  injectIntl,
} from 'react-intl';
import {
  gatewayStats,
  gatewayPing,
  gatewayReset,
  gatewayUpgradeSDK,
  gatewayUpgradeSDKCom,
} from 'loraapi/lora_gateway';
import usageActions from 'loraactions/usage';

import LineChart from 'loracoms/LineChart';
import ActionButton from 'loracoms/ActionButton';
import RichButton from 'loracoms/RichButton';
import Refresher from 'loracoms/Refresher';
import DetailEye from 'loracoms/DetailEye';
import CollapseToggle from 'loracoms/CollapseToggle';
import Toolbar from 'loracoms/Toolbar';
import gatewayActions from 'loraactions/gateway';
import IntlMsg from 'lorautils/intl/IntlMsg';
import GatewayProps from '../GatewayProps';
import BriefGatewayData from '../BriefGatewayData';
import styles from './styles.scss';


const messages = defineMessages({
  breadcrumbGateways: {
    id: 'gatewaydetail.breadcrumbs.gateways',
    defaultMessage: '我的网关',
  },
  chartAxisPkts: {
    id: 'gatewaydetail.statschart.axis.pkts',
    defaultMessage: 'gatewaydetail.statschart.axis.pkts',
  },
  chartAxisLatency: {
    id: 'gatewaydetail.statschart.axis.latency',
    defaultMessage: 'gatewaydetail.statschart.axis.latency',
  },
  chartPkts: {
    id: 'gatewaydetail.statschart.series.pkts',
    defaultMessage: 'gatewaydetail.statschart.series.pkts',
  },
  chartLatency: {
    id: 'gatewaydetail.statschart.series.latency',
    defaultMessage: 'gatewaydetail.statschart.series.latency',
  },
});


const propTypes = {
  intl: React.PropTypes.any.isRequired,
  pushState: React.PropTypes.func.isRequired,
  gatewayId: React.PropTypes.string.isRequired,
  gateway: React.PropTypes.object.isRequired,
  deleteGateway: React.PropTypes.func.isRequired,
  deleteResult: React.PropTypes.object.isRequired,
  resetDeleteGateway: React.PropTypes.func.isRequired,
  getGateway: React.PropTypes.func.isRequired,
  getGatewaysUsage: React.PropTypes.func.isRequired,
};

class DetailView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      gateway: props.gateway,
      deleteResult: props.deleteResult,
      statSeries: {
        rxpks: {
          name: this.props.intl.formatMessage(messages.chartPkts),
          data: [],
          yAxisIndex: 0,
        },
        ltncs: {
          name: this.props.intl.formatMessage(messages.chartLatency),
          data: [],
          yAxisIndex: 1,
        },
        categories: [],
      },
      pingStatus: 'ready',
      resetStatus: 'ready',
      upgradeStatus: 'ready',
      comUpgradeStatus: '',
    };
    this.handleReloadStats = this.handleReloadStats.bind(this);
    this.handleDeleteConfirm = this.handleDeleteConfirm.bind(this);
    this.handlePingGateway = this.handlePingGateway.bind(this);
    this.handleResetGateway = this.handleResetGateway.bind(this);
    this.handleSDKupgrade = this.handleSDKupgrade.bind(this);
    this.handleSDKUpgradeSta = this.handleSDKUpgradeSta.bind(this);
    this.intlMsg = new IntlMsg(props.intl, 'gatewaydetail.detailview');
  }

  componentDidMount() {
    this.mounted = true;
    this.loadStats();
  }

  componentWillReceiveProps(nextProps) {
    const { gateway, deleteResult, getGatewaysUsage } = nextProps;

    if (gateway !== this.props.gateway) {
      this.setState({ gateway });
    }
    if (deleteResult !== this.props.deleteResult) {
      this.setState({ deleteResult });
      if (deleteResult.status === 'success') {
        getGatewaysUsage();
      }
    }
  }

  componentWillUnmount() {
    this.mounted = false;
    const { resetDeleteGateway } = this.props;
    resetDeleteGateway();

    if (this.pingTimeout) {
      clearTimeout(this.pingTimeout);
    }
    if (this.resetTimeout) {
      clearTimeout(this.resetTimeout);
    }
    if (this.upgradeTimeout) {
      clearTimeout(this.upgradeTimeout);
    }
  }


  loadStats(cb) {
    const { gatewayId } = this.props;
    const from = moment().subtract(7, 'days').format('YYYYMMDDHH');
    const to = moment().add(1, 'hours').format('YYYYMMDDHH');
    const formatSlot = (s) => {
      const str = String(s);
      return `${str.slice(6, 8)}/${str.slice(4, 6)} ${str.slice(8, 10)}:00`;
    };
    gatewayStats(gatewayId, from, to).then((res) => {
      const rxpks = [];
      const ltncs = [];
      const slots = [];
      res.body.list.forEach((item) => {
        slots.push(formatSlot(item.slot));
        rxpks.push(item.rxpkt);
        ltncs.push(item.latency);
      });

      const statSeries = _.extend({}, this.state.statSeries);
      statSeries.rxpks.data = rxpks;
      statSeries.ltncs.data = ltncs;
      statSeries.categories = slots;
      if (this.mounted) {
        this.setState({
          statSeries,
        });
      }

      if (cb) {
        cb();
      }
    }).catch(() => {
      if (cb) {
        cb();
      }
    });
  }

  handleReloadStats() {
    this.setState({
      statReloading: true,
    });

    this.loadStats(() => {
      this.setState({
        statReloading: false,
      });
    });
  }

  handlePingGateway() {
    const { getGateway, gatewayId } = this.props;
    this.setState({
      pingStatus: 'loading',
    });

    if (this.pingTimeout) {
      clearTimeout(this.pingTimeout);
    }

    gatewayPing(gatewayId).then(() => {
      if (this.mounted) {
        this.setState({
          pingStatus: 'success',
        });
        this.pingTimeout = setTimeout(() => {
          getGateway(gatewayId);
        }, 3000);
      }
    }).catch(() => {
      if (this.mounted) {
        this.setState({
          pingStatus: 'failed',
        });
        this.pingTimeout = setTimeout(() => {
          getGateway(gatewayId);
        }, 3000);
      }
    });
  }

  handleResetGateway() {
    const { gatewayId, getGateway } = this.props;
    this.setState({
      resetStatus: 'loading',
    });

    if (this.resetTimeout) {
      clearTimeout(this.resetTimeout);
    }

    gatewayReset(gatewayId).then(() => {
      if (this.mounted) {
        this.setState({
          resetStatus: 'success',
        });
        this.resetTimeout = setTimeout(() => {
          getGateway(gatewayId);
        }, 3000);
      }
    }).catch(() => {
      if (this.mounted) {
        this.setState({
          resetStatus: 'failed',
        });
        this.resetTimeout = setTimeout(() => {
          getGateway(gatewayId);
        }, 3000);
      }
    });
  }

  handleSDKupgrade() {
    const { gatewayId, getGateway } = this.props;
    this.setState({
      upgradeStatus: 'loading',
    });

    if (this.upgradeTimeout) {
      clearTimeout(this.upgradeTimeout);
    }

    gatewayUpgradeSDK(gatewayId).then((res) => {
      if (this.mounted) {
        const { supported, suggested, srcver, dstver } = res.body;
        this.setState({ upgradeStatus: 'success', srcver, dstver });
        if (!supported) {
          this.setState({
            showSDKupgradeTip: true,
            tipWord: this.intlMsg.msg('NoSupportUpSDK'),
            upgradeStatus: 'ready',
          });
        } else if (supported) {
          if (suggested) {
            this.setState({
              showSDKupgrade: true,
              upgradeStatus: 'ready',
              upgradeStatusSta: 'ready',
            });
          } else if (!suggested) {
            this.setState({
              showSDKupgradeTip: true,
              tipWord: this.intlMsg.msg('NoUpgradeSDK'),
              upgradeStatus: 'ready',
            });
          }
        }
      }
    }).catch(() => {
      if (this.mounted) {
        this.setState({
          upgradeStatus: 'failed',
        });
        this.upgradeTimeout = setTimeout(() => {
          getGateway(gatewayId);
        }, 3000);
      }
    });
  }

  handleSDKUpgradeSta() {
    const { gatewayId } = this.props;

    this.setState({
      upgradeStatusSta: 'loading',
      cancelDis: 'disabled',
      backdr: 'static',
    });

    gatewayUpgradeSDKCom(gatewayId).then(() => {
      this.setState({
        showSDKupgrade: false,
        showSDKupgradeTip: true,
        tipWord: this.intlMsg.msg('upgradeSDKSuccTips'),
        upgradeStatusSta: 'ready',
        cancelDis: '',
        backdr: true,
      });
    }).catch(() => {
      this.setState({
        upgradeStatusSta: 'failed',
        cancelDis: '',
        backdr: true,
      });
    });
  }

  handleDeleteConfirm() {
    const { gatewayId, deleteGateway } = this.props;
    deleteGateway(gatewayId);
  }

  renderSDKupgradeTipModal() {
    const { gateway = {}, tipWord = '' } = this.state;
    const { name, id } = gateway;

    return (
      <Modal
        bsClass="aisz-modal-danger"
        show={this.state.showSDKupgradeTip}
        onHide={() => this.setState({ showSDKupgradeTip: false })}
      >
        <Modal.Header closeButton>
          <div className="text-center">
            <i className="fa fa-upload" />
            {' '}
            {this.intlMsg.msg('upgradeSDK')}
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">
            <p>
              <strong>{name}</strong> ({id}){' '}
              {tipWord}
            </p>
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  renderSDKupgradeModal() {
    const {
      gateway = {},
      showSDKupgrade,
      upgradeStatusSta = 'ready',
      cancelDis = '',
      backdr = true,
      srcver = '',
      dstver = '',
    } = this.state;
    const { name, id } = gateway;

    return (
      <Modal
        bsClass="aisz-modal-danger"
        show={showSDKupgrade}
        onHide={() => this.setState({ showSDKupgrade: false })}
        backdrop={backdr}
      >
        <Modal.Header>
          <div className="text-center">
            <i className="fa fa-upload" />
            {' '}
            {this.intlMsg.msg('upgradeSDK')}
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">
            <p>
              <strong>{name}</strong> ({id}){' '}
              {this.intlMsg.msg('sugUpgrade')}
            </p>
            <p>
              {this.intlMsg.msg('newVer')}{'： '}
              <strong>{dstver}</strong>
            </p>
            <p>
              {this.intlMsg.msg('currentVer')}{'： '}
              <strong>{srcver}</strong>
            </p>
            <div>
              <Button
                bsStyle="aisz-warning"
                onClick={() => this.setState({ showSDKupgrade: false })}
                disabled={cancelDis}
              >
                <i className="fa fa-repeat" />
                {' '}
                {this.intlMsg.msg('upgrade.cancelbtn')}
              </Button>
              {' '}
              <ActionButton
                onClick={this.handleSDKUpgradeSta}
                status={upgradeStatusSta}
                onStatusReset={() => this.setState({ upgradeStatus: 'ready' })}
                icon={<i className="fa fa-upload" />}
                label={this.intlMsg.msg('upgradeSDKDur')}
                loadingLabel={this.intlMsg.msg('upgradeSDKDur')}
                failedLabel={this.intlMsg.msg('upgradeSDKfail')}
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  renderDeleteModal() {
    const { pushState } = this.props;
    const { gateway = {}, deleteResult = {} } = this.state;
    const { status: deleteStatus = '' } = deleteResult;
    const { name, id } = gateway;

    return (
      <Modal
        bsClass="aisz-modal-danger"
        show={this.state.showDeleteModal}
        onHide={() => this.setState({ showDeleteModal: false })}
      >
        <Modal.Header closeButton>
          <div className="text-center">
            <i className="fa fa-exclamation-triangle" />
            {' '}
            {this.intlMsg.msg('delete.modalheader')}
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">
            <p>
              {this.intlMsg.msg('delete.modalcontent')}{' '}
              <strong>{name}</strong> ({id}) ?
            </p>
            <div>
              <Button
                bsStyle="aisz-warning"
                onClick={() => this.setState({ showDeleteModal: false })}
              >
                <i className="fa fa-repeat" />
                {' '}
                {this.intlMsg.msg('delete.cancelbtn')}
              </Button>
              {' '}
              <RichButton
                status={deleteStatus}
                states={[{
                  status: '',
                  label: (
                    <span>
                      <i className="fa fa-trash-o" />
                      {' '}
                      {this.intlMsg.msg('delete.confirmbtn')}
                    </span>
                  ),
                  style: 'danger',
                  onClick: this.handleDeleteConfirm,
                }, {
                  status: 'request',
                  label: this.intlMsg.msg('delete.deleting'),
                  style: 'info',
                }, {
                  status: 'pending',
                  label: this.intlMsg.msg('delete.deleting'),
                  style: 'info',
                }, {
                  status: 'success',
                  label: this.intlMsg.msg('delete.success'),
                  style: 'success',
                  timer: () => pushState('/gateway'),
                  delay: 500,
                }, {
                  status: 'failure',
                  label: this.intlMsg.msg('delete.failure'),
                  style: 'danger',
                }]}
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  renderToolbar() {
    const { pushState } = this.props;
    const { gateway: { name } = {} } = this.state;
    const { upgradeStatus } = this.state;

    const breadcrumb = [{
      content: this.props.intl.formatMessage(messages.breadcrumbGateways),
      onClick: () => pushState('/gateway'),
    }, {
      content: name,
      active: true,
    }];

    const rightTools = [{
      type: 'buttons',
      buttons: [(
        <ActionButton
          onClick={this.handlePingGateway}
          status={this.state.pingStatus}
          onStatusReset={() => this.setState({ pingStatus: 'ready' })}
          icon={<i className="fa fa-heartbeat" />}
          label={this.intlMsg.msg('ping')}
          successLabel={this.intlMsg.msg('pingsucc')}
          failedLabel={this.intlMsg.msg('pingfail')}
        />
      ), (
        <ActionButton
          onClick={this.handleResetGateway}
          status={this.state.resetStatus}
          onStatusReset={() => this.setState({ resetStatus: 'ready' })}
          icon={<i className="fa fa-repeat" />}
          label={this.intlMsg.msg('restart')}
          successLabel={this.intlMsg.msg('restartsucc')}
          failedLabel={this.intlMsg.msg('restartfail')}
        />
      ), (
        <ActionButton
          onClick={this.handleSDKupgrade}
          status={upgradeStatus}
          onStatusReset={() => this.setState({ upgradeStatus: 'ready' })}
          icon={<i className="fa fa-upload" />}
          label={this.intlMsg.msg('upgradeSDK')}
          loadingLabel={this.intlMsg.msg('upgradeSDK')}
          failedLabel={this.intlMsg.msg('upgradeSDKfail')}
        />
      ), (
        <Button
          bsStyle="aisz-danger"
          onClick={() => this.setState({ showDeleteModal: true })}
        >
          <i className="fa fa-trash-o" />
          {' '}
          {this.intlMsg.msg('delete')}
        </Button>
      )],
    }];

    return <Toolbar breadcrumb={breadcrumb} rightTools={rightTools} />;
  }

  renderChartPanel() {
    const { gatewayId, pushState } = this.props;
    const { statReloading, chartPanelExpanded = true, resizeTrigger = 0 } = this.state;
    const chartPanelHeader = (
      <div>
        <span>
          {this.intlMsg.msg('panel.header.gwstat')}
        </span>
        <ul className="icontools">
          <li>
            <DetailEye onClick={() => pushState(`/gateway/detail/${gatewayId}/stat`)} />
          </li>
          <li>
            <Refresher reloading={statReloading} onReload={this.handleReloadStats} />
          </li>
          <li>
            <CollapseToggle
              expanded={chartPanelExpanded}
              onChange={(expanded) => {
                this.setState({ chartPanelExpanded: expanded });
              }}
            />
          </li>
        </ul>
      </div>
    );


    return (
      <Panel
        bsStyle="aisz-white"
        header={chartPanelHeader}
        collapsible
        expanded={chartPanelExpanded}
        onEntered={() => { this.setState({ resizeTrigger: Math.random() }); }}
      >
        <LineChart
          yAxis={[{
            name: this.props.intl.formatMessage(messages.chartAxisPkts),
            splitNumber: 5,
          }, {
            name: this.props.intl.formatMessage(messages.chartAxisLatency),
            splitLine: {
              show: false,
            },
          }]}
          xAxis={{
            axisTick: {
              alignWithLabel: true,
            },
            boundaryGap: true,
          }}
          legend={{
            data: [
              this.props.intl.formatMessage(messages.chartPkts),
              this.props.intl.formatMessage(messages.chartLatency),
            ],
          }}
          grid={{
            left: 60,
            top: 30,
            right: 60,
            bottom: 30,
          }}
          series={[
            this.state.statSeries.rxpks,
            this.state.statSeries.ltncs,
          ]}
          categories={this.state.statSeries.categories}
          resizeTrigger={resizeTrigger}
        />
      </Panel>
    );
  }

  render() {
    const { gatewayId } = this.props;
    const { gateway } = this.state;

    const content = (
      <Grid fluid>
        <Row>
          <Col md={12}>
            {this.renderToolbar()}
          </Col>
        </Row>
        <Row>
          <Col md={8} className="collapse-right">
            {this.renderChartPanel()}
            <BriefGatewayData gatewayId={gatewayId} />
          </Col>
          <Col md={4}>
            <GatewayProps
              gatewayId={gatewayId}
              gateway={gateway}
            />
          </Col>
        </Row>
      </Grid>
    );
    return (
      <div>
        {content}
        <div>
          {this.renderDeleteModal()}
          {this.renderSDKupgradeTipModal()}
          {this.renderSDKupgradeModal()}
        </div>
      </div>
    );
  }
}

DetailView.propTypes = propTypes;


const mapStateToProps = (state, ownProps) => ({
  gateway: state.gateway.gateway.data || {},
  deleteResult: state.gateway.deleteGateway || {},
  gatewayId: ownProps.params.id,
});

const mapDispatchToProps = ({
  pushState: routerActions.push,
  getGateway: gatewayActions.gateway,
  deleteGateway: gatewayActions.deleteGateway,
  resetDeleteGateway: gatewayActions.resetDeleteGateway,
  getGatewaysUsage: usageActions.gateways,
});

export default connect(mapStateToProps, mapDispatchToProps)(
  injectIntl(CSSModules(DetailView, styles, { allowMultiple: true })));




// WEBPACK FOOTER //
// ./src/containers/Gateway/coms/GatewayDetail/coms/DetailView/index.jsx